import { TextField } from '@material-ui/core';
import React, { useCallback } from 'react';
import InputMask from 'react-input-mask';
import { useSelector } from 'react-redux';
import { ApplicationState } from '~/store';
import { Container } from './styles';

interface IProps {
  pageTitle?: string;
}

const HeaderPage: React.FC<IProps> = ({ pageTitle = 'pageTitle', ...rest }) => {
  const language = useSelector<ApplicationState, any>(
    state => state.language.data,
  );

  const infoHeader = useSelector<ApplicationState, any>(
    state => state.user.infoHeader,
  );

  const auth = useSelector<ApplicationState, any>(state => state.auth);
  const common = useSelector<ApplicationState, any>(state => state.common);

  const renderHeader = useCallback(() => {
    const index = common.categoria?.findIndex(
      (el: any) => el.data_holder_cat_id === infoHeader?.ownership_type,
    );

    const ownershipType = common.categoria[index].data_holder_cat_name;

    return (
      <div className="login-information">
        <TextField
          id="country-company"
          disabled
          title={`${auth.company.company?.company_name}-${auth.company.country?.country_name}`}
          label={language?.gerenciarConsentimento?.paisEmpresa}
          value={`${auth.company.company.company_name}-${auth.company.country.country_name}`}
          variant="outlined"
          className="TextField-lgpd"
        />
        <TextField
          id="category"
          disabled
          title={ownershipType}
          label={language?.gerenciarConsentimento?.categoria}
          value={ownershipType}
          variant="outlined"
          className="TextField-lgpd"
        />

        {common.categoria[index].data_holder_cat_id === '5' &&
        auth.company.country_company_id === 2 ? (
          <TextField
            disabled
            value={infoHeader.identification_key}
            title={infoHeader.identification_key}
            id="identification-key"
            name="identification-key"
            label="E-mail"
            variant="outlined"
            className="TextField-lgpd"
          />
        ) : (
          <InputMask
            mask="999.999.999-99"
            value={infoHeader.identification_key}
            disabled
            maskChar=""
            children={() => (
              <TextField
                disabled
                title={infoHeader.identification_key}
                id="identification-key"
                name="identification-key"
                label={language?.gerenciarConsentimento?.chaveDeIdentificacao}
                variant="outlined"
                className="TextField-lgpd"
              />
            )}
          />
        )}
      </div>
    );
  }, [
    auth.company.company,
    auth.company.country,
    auth.company.country_company_id,
    common.categoria,
    infoHeader,
    language,
  ]);

  return (
    <Container>
      <div className="header">
        <h1>{pageTitle}</h1>

        {infoHeader && renderHeader()}
      </div>
    </Container>
  );
};

export default HeaderPage;
